export const constructionVisitSurveyConstants = {
  SET_SURVEY: "CONSTRUCTION_VISIT_SURVEY_SET_SURVEY",
  SET_SURVEY_IDENTITY: "CONSTRUCTION_VISIT_SURVEY_SET_SURVEY_IDENTITY",
  RESET_SURVEY_IDENTITY: "CONSTRUCTION_VISIT_SURVEY_RESET_SURVEY_IDENTITY",
  RESET_ALL: "CONSTRUCTION_VISIT_SURVEY_RESET_ALL"
};
